// src/components/common/StatusBadge.jsx
import React from 'react';

const STATUS_CONFIG = {
    // Progetti
    DRAFT: { label: 'Bozza', classes: 'bg-gray-100 text-gray-700' },
    PLANNED: { label: 'Pianificato', classes: 'bg-blue-100 text-blue-700' },
    IN_PROGRESS: { label: 'In Corso', classes: 'bg-emerald-100 text-emerald-700' },
    ON_HOLD: { label: 'In Attesa', classes: 'bg-yellow-100 text-yellow-700' },
    DELAYED: { label: 'Ritardato', classes: 'bg-orange-100 text-orange-700' },
    COMPLETED: { label: 'Completato', classes: 'bg-purple-100 text-purple-700' },
    CANCELLED: { label: 'Cancellato', classes: 'bg-red-100 text-red-700' },

    // Priorità
    LOW: { label: 'Bassa', classes: 'bg-gray-100 text-gray-600' },
    MEDIUM: { label: 'Media', classes: 'bg-blue-100 text-blue-700' },
    HIGH: { label: 'Alta', classes: 'bg-orange-100 text-orange-700' },
    URGENT: { label: 'Urgente', classes: 'bg-red-100 text-red-700' },
    CRITICAL: { label: 'Critica', classes: 'bg-red-200 text-red-800' },

    // Spese
    VALIDATED: { label: '✓ Validata', classes: 'bg-emerald-100 text-emerald-700' },
    PENDING: { label: '⏳ Attesa', classes: 'bg-yellow-100 text-yellow-700' },

    // Utenti
    ACTIVE: { label: 'Attivo', classes: 'bg-emerald-100 text-emerald-700' },
    INACTIVE: { label: 'Inattivo', classes: 'bg-gray-100 text-gray-600' },

    // Ruoli
    SUPER_ADMIN: { label: 'Super Admin', classes: 'bg-purple-100 text-purple-700' },
    SITE_MANAGER: { label: 'Capo Cantiere', classes: 'bg-blue-100 text-blue-700' },
    ENGINEER: { label: 'Ingegnere', classes: 'bg-indigo-100 text-indigo-700' },
    ACCOUNTANT: { label: 'Contabile', classes: 'bg-emerald-100 text-emerald-700' },
    FIELD_SUPERVISOR: { label: 'Supervisore', classes: 'bg-yellow-100 text-yellow-700' },
    VIEWER: { label: 'Visualizzatore', classes: 'bg-gray-100 text-gray-600' },

    // Inviti
    INVITE_PENDING: { label: 'In Attesa', classes: 'bg-yellow-100 text-yellow-700' },
    ACCEPTED: { label: 'Accettato', classes: 'bg-emerald-100 text-emerald-700' },
    EXPIRED: { label: 'Scaduto', classes: 'bg-red-100 text-red-700' },
    INVITE_CANCELLED: { label: 'Cancellato', classes: 'bg-gray-100 text-gray-600' },

    // Piani
    FREE: { label: 'Free', classes: 'bg-gray-100 text-gray-700' },
    PRO: { label: 'PRO', classes: 'bg-purple-100 text-purple-700' },
    ENTERPRISE: { label: 'Enterprise', classes: 'bg-yellow-100 text-yellow-800' },
};

const SIZES = {
    xs: 'px-1.5 py-0.5 text-[10px]',
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-sm',
};

const StatusBadge = ({ status, size = 'sm' }) => {
    const config = STATUS_CONFIG[status] || { label: status || '—', classes: 'bg-gray-100 text-gray-600' };
    return (
        <span className={`inline-flex items-center rounded-full font-medium ${SIZES[size] || SIZES.sm} ${config.classes}`}>
            {config.label}
        </span>
    );
};

export default StatusBadge;